/** Canonical Witro shop routes. */
export const SHOP_HOME_PATH = '/';
export const SHOP_PLP_PATH = '/products';
export const SHOP_CATEGORIES_PATH = '/categories';

export const SHOP_SEARCH_PRODUCTS_PATH = '/search/products';
export const SHOP_SEARCH_VENDORS_PATH = '/search/vendors';
export const SHOP_SEARCH_PATH = '/search';

export const SHOP_SEARCH_ACTION_TEMPLATE =
  '/search/products?queryText={search_term_string}';
